import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex h-15 w-15 items-center justify-center overflow-hidden rounded-full border-2 border-orange-600 bg-orange-50 text-2xl font-bold uppercase text-orange-600" };
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({ __name: 'base-avatar', props: { name: null }, setup(__props) {
        const props = __props;
        const initials = computed(() => {
            const [first, last] = props.name.split(' '); // eslint-disable-next-line no-magic-numbers
            if (!last)
                return first.slice(0, 2);
            return `${first[0]}${last[0]}`;
        });
        return (_ctx, _cache) => { return _openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(initials)), 1); };
    } });
